export default __webpack_public_path__ + "static/media/NFCU_Mob_Logo-1d62888b4b662af9142e3c385f423f32.3d364b8d.svg";